import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
// import SemiPieChart from "../../common/SemiPieChart";
// import ColumnChart from "../../common/ColumnChart";
import DataTableBase from "../../common/DateTableBase";
import axios from "axios";
import { API_URL } from "../../../utility";
import { useNavigate } from "react-router-dom";
import Loader from "../../common/Loader";
import { FaBahtSign } from "react-icons/fa6";



const Overview = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("admin_token");
        axios.get(`${API_URL}/admin/overview`, { headers: { 'Authorization': `Bearer ${token}` } }).then((res) => {
            // console.log("Admin OVerview res : ", res);
            setData(res?.data?.data);
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            // console.log("Admin Overview error : ", err);
        })
    }, [])

    const columns = [
        {
            name: 'No.',
            width: '60px',
            center: true,
            selector: (row, index) => index + 1,
        },
        {
            name: 'User',
            selector: row => row?.name,
        },
        // {
        //     name: 'Status',
        //     selector: row => row?.status === "Success"? <span className="active-status">Success</span> : row?.status === "Pending" ? <span className="text-warning">Pending</span> : <span className="inactive-status">Failed</span>,
        // },
        {
            name: 'Total Charging',
            width: '130px',
            center: true,
            selector: row => Number(row?.fund_amount).toLocaleString(),
        }
    ];

    const columns2 = [
        {
            name: 'No.',
            width: '70px',
            center: true,
            selector: row => row?.id,
        },
        {
            name: 'Date',
            maxWidth: '110px',
            center: true,
            selector: row => {
                if (row?.created_at) {
                    let date = new Date(row?.created_at);
                    let formateDate = date.toISOString()?.split('T')[0];
                    return formateDate;
                }
            },
        },
        {
            name: 'Time',
            center: true,
            maxWidth: '100px',
            selector: row => {
                if (row?.created_at) {
                    let date = new Date(row?.created_at);
                    let formateDate = date.toISOString()?.split('T')[1];
                    let time = formateDate?.split('.')[0];
                    return time;
                }
            },
        },
        {
            name: 'User',
            selector: row => row?.name,
        },
        {
            name: 'Transfer',
            center: true,
            maxWidth: '150px',
            selector: row => row?.transfer_type,
        },
        // {
        //     name: 'Status',
        //     selector: row => row.status === 1? <span className="active-status">Active</span> : <span className="inactive-status">Inactive</span>,
        // },
        {
            name: 'Fund',
            center: true,
            maxWidth: '150px',
            selector: row => Number(row?.fund_amount).toLocaleString(),
        },
        {
            name: 'View',
            center: true,
            maxWidth: '90px',
            selector: row => <svg className="pointer" onClick={() => navigate(`/fund-requests/detail/${row?.id}`)} xmlns="http://www.w3.org/2000/svg" width="26" height="22.771" viewBox="1746.229 438.416 22.771 22.771"><path d="M1756.102 438.444c-5.445 0-9.873 4.429-9.873 9.873 0 5.444 4.428 9.873 9.873 9.873 1.664 0 3.3-.395 4.682-1.157.111.134.234.256.367.367l2.82 2.821a2.877 2.877 0 1 0 4.063-4.062l-2.82-2.82a2.821 2.821 0 0 0-.452-.368c.761-1.382 1.24-2.99 1.24-4.682 0-5.445-4.428-9.873-9.872-9.873Zm0 2.82a7.019 7.019 0 0 1 7.052 7.053c0 1.862-.677 3.582-1.862 4.852l-.085.084c-.133.111-.256.234-.366.367-1.241 1.129-2.934 1.777-4.768 1.777a7.019 7.019 0 0 1-7.052-7.052 7.019 7.019 0 0 1 7.052-7.052Z" fill="#197547" fill-rule="evenodd" data-name="Icon open-magnifying-glass"/></svg>
        },
    ];


    console.log("dagjhjhgta : ", data?.top3Funds ? data?.top3Funds : []);

    if (loading) {
        return (
            <Loader />
        )
    } else {
        return (
            <div className="overview">
                <h1 className="overviewText mt-3 pb-4">Overview</h1>

                <Row>

                    {/* New Stat Cards */}
                    <Col sm={12} md={6} xl={4} className="d-flex justify-content-center align-items-center mt-3 mb-2">
                        <div className="statTextBox">
                            <h2>Total User</h2>
                            <p>{data?.totalUser ? (Number(data?.totalUser)).toLocaleString() : 0} <span>Accounts</span> </p>
                            <div className="statIcon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="29.063" height="29.063"><path d="M14.531 0C6.504 0 0 6.504 0 14.531c0 8.028 6.504 14.531 14.531 14.531 8.028 0 14.531-6.503 14.531-14.53C29.063 6.503 22.56 0 14.533 0Zm0 5.625a5.156 5.156 0 1 1 0 10.313 5.156 5.156 0 0 1 0-10.313Zm0 20.156c-3.44 0-6.521-1.558-8.584-3.996 1.102-2.074 3.258-3.504 5.772-3.504.14 0 .281.024.416.065.761.246 1.558.404 2.396.404.838 0 1.64-.158 2.397-.404.134-.041.275-.065.416-.065 2.513 0 4.67 1.43 5.771 3.504-2.062 2.438-5.144 3.996-8.584 3.996Z" fill="#808080" fill-rule="evenodd" data-name="Icon awesome-user-circle" /></svg>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} md={6} xl={4} className="d-flex justify-content-center align-items-center mt-3 mb-2">
                        <div className="statTextBox">
                            <h2>Active User</h2>
                            <p>{data?.totalActiveUser ? (Number(data?.totalActiveUser)).toLocaleString() : 0} <span>Accounts</span> </p>
                            <div className="statIcon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="29.063" height="29.063"><path d="M14.531 0C6.504 0 0 6.504 0 14.531c0 8.028 6.504 14.531 14.531 14.531 8.028 0 14.531-6.503 14.531-14.53C29.063 6.503 22.56 0 14.533 0Zm0 5.625a5.156 5.156 0 1 1 0 10.313 5.156 5.156 0 0 1 0-10.313Zm0 20.156c-3.44 0-6.521-1.558-8.584-3.996 1.102-2.074 3.258-3.504 5.772-3.504.14 0 .281.024.416.065.761.246 1.558.404 2.396.404.838 0 1.64-.158 2.397-.404.134-.041.275-.065.416-.065 2.513 0 4.67 1.43 5.771 3.504-2.062 2.438-5.144 3.996-8.584 3.996Z" fill="#197547" fill-rule="evenodd" data-name="Icon awesome-user-circle" /></svg>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} md={6} xl={4} className="d-flex justify-content-center align-items-center mt-3 mb-2">
                        <div className="statTextBox">
                            <h2>Vcard</h2>
                            <p>2222 <span>Cars</span> </p> {/* Vcard data endpooint is unknown */}
                            <div className="statIcon">
                                <svg width="33" height="33" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 7.548c0 .66-.54 1.2-1.2 1.2H3.2c-.66 0-1.2-.54-1.2-1.2v-.01c0-2.29 1.85-4.14 4.14-4.14h11.71c2.29 0 4.15 1.86 4.15 4.15M2 11.45v5.01c0 2.29 1.85 4.14 4.14 4.14h11.71c2.29 0 4.15-1.86 4.15-4.15v-5c0-.66-.54-1.2-1.2-1.2H3.2c-.66 0-1.2.54-1.2 1.2m6 5.8H6c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75s-.34.75-.75.75m6.5 0h-4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75" fill="#197547"/></svg>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} md={6} xl={4} className="d-flex justify-content-center align-items-center mt-3 mb-2">
                        <div className="statTextBox">
                            <h2>Total Top up</h2>
                            <p>{data?.totalFund ? (Number(data?.totalFund)).toLocaleString() : 0} <span>THB</span> </p>
                            <div className="statIcon">
                                <FaBahtSign color="#197547" size="0.9cm" />
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} md={6} xl={4} className="d-flex justify-content-center align-items-center mt-3 mb-2">
                        <div className="statTextBox">
                            <h2>Used</h2>
                            <p>{data?.totalUsedPoint ? (Number(data?.totalUsedPoint)).toLocaleString() : 0} <span>Points</span> </p>
                            <div className="statIcon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-200 0 784 512" fill="#197547"><path d="M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.3-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8l0 464c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488L0 24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 144zM80 352c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 336c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 240z"/></svg>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} md={6} xl={4} className="d-flex justify-content-center align-items-center mt-3 mb-2">
                        <div className="statTextBox">
                            <h2>Balance</h2>
                            <p>{data?.totalPoints ? (Number(data?.totalPoints)).toLocaleString() : 0} <span>Points</span> </p>
                            <div className="statIcon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-155 0 748 512" fill="#197547"><path d="M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM192 256l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0 0 64zm48 64l-48 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64 0-120c0-22.1 17.9-40 40-40l72 0c53 0 96 43 96 96s-43 96-96 96z"/></svg>
                            </div>
                        </div>
                    </Col>


                    <Col md={12} className="mt-3">
                        <div className="overview-table-div">
                            <div className="headerWrapper d-flex justify-content-between align-items-center pb-4">
                                <h2 className="chartTableHeader d-flex align-items-center">
                                    <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" width="33.75" height="30" viewBox="418 965.832 33.75 30"><path d="M450.344 969.582h-6.094v-2.344c0-.779-.627-1.406-1.406-1.406h-15.938c-.779 0-1.406.627-1.406 1.406v2.344h-6.094c-.779 0-1.406.627-1.406 1.406v3.282c0 2.091 1.318 4.242 3.627 5.9 1.846 1.33 4.09 2.174 6.445 2.443 1.84 3.053 3.99 4.313 3.99 4.313v4.219h-2.812c-2.068 0-3.75 1.212-3.75 3.28v.704c0 .387.316.703.703.703h17.344a.705.705 0 0 0 .703-.703v-.703c0-2.069-1.682-3.281-3.75-3.281h-2.813v-4.22s2.15-1.259 3.99-4.312c2.362-.27 4.606-1.113 6.446-2.443 2.303-1.658 3.627-3.809 3.627-5.9v-3.282c0-.779-.627-1.406-1.406-1.406Zm-26.526 7.547c-1.43-1.031-2.068-2.18-2.068-2.86v-.937h3.762c.058 1.91.34 3.586.75 5.05a9.443 9.443 0 0 1-2.444-1.253Zm24.182-2.86c0 .944-1.037 2.116-2.068 2.86a9.48 9.48 0 0 1-2.45 1.254c.41-1.465.692-3.14.75-5.051H448v.938Z" fill-rule="evenodd" data-name="Icon awesome-trophy" /></svg>
                                    TOP 3 Fund Added (Grand Total)
                                    {/* <span>{currentMonthYear()}</span> */}
                                </h2>
                            </div>

                            <div className="lbPodium d-flex align-items-end justify-content-center mb-4">
                                {/* #2 */}
                                <div className="podiumTextBox" style={{ border: "2px solid #C0C0C0", boxShadow: "0 2px 8px #C0C0C0", height: "230px" }}>
                                    <h2>{data?.top3Funds[1]?.name}</h2>
                                    <p>{Number(data?.top3Funds[1]?.fund_amount).toLocaleString()}</p>
                                    <span className="podiumUnit">Points</span>
                                    <div className="podiumIcon">
                                        <svg width="48" height="48" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="iconify iconify--twemoji"><path fill="#55ACEE" d="m18 8-7-8H0l14 17 11.521-4.75z" /><path fill="#3B88C3" d="m25 0-7 8 5.39 7.312 1.227-1.489L36 0z" /><path fill="#CCD6DD" d="M23.205 16.026c.08-.217.131-.448.131-.693a2 2 0 0 0-2-2h-6.667a2 2 0 0 0-2 2c0 .245.05.476.131.693-3.258 1.826-5.464 5.307-5.464 9.307C7.335 31.224 12.111 36 18.002 36s10.667-4.776 10.667-10.667c0-4-2.206-7.481-5.464-9.307" /><path fill="#627077" d="M22.002 28.921h-3.543c.878-1.234 2.412-3.234 3.01-4.301.449-.879.729-1.439.729-2.43 0-2.076-1.57-3.777-4.244-3.777-2.225 0-3.74 1.832-3.74 1.832-.131.15-.112.374.019.487l1.141 1.159a.36.36 0 0 0 .523 0c.355-.393 1.047-.935 1.813-.935 1.047 0 1.646.635 1.646 1.346 0 .523-.243 1.047-.486 1.421-1.104 1.682-3.871 5.441-4.955 6.862v.374c0 .188.149.355.355.355h7.732a.37.37 0 0 0 .355-.355v-1.682a.367.367 0 0 0-.355-.356" /></svg>
                                    </div>
                                </div>

                                {/* #1 */}
                                <div className="podiumTextBox ms-4 me-4" style={{ border: "2px solid #FFD700", boxShadow: "0 2px 8px rgb(255, 215, 0, 0.5)", height: "280px" }}>
                                    <h2>{data?.top3Funds[0]?.name}</h2>
                                    <p>{Number(data?.top3Funds[0]?.fund_amount).toLocaleString()}</p>
                                    <span className="podiumUnit">Points</span>
                                    <div className="podiumIcon mb-4">
                                        <svg width="48" height="48" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="iconify iconify--twemoji"><path fill="#55ACEE" d="m18 8-7-8H0l14 17 11.521-4.75z" /><path fill="#3B88C3" d="m25 0-7 8 5.39 7.312 1.227-1.489L36 0z" /><path fill="#FFAC33" d="M23.205 16.026c.08-.217.131-.448.131-.693a2 2 0 0 0-2-2h-6.667a2 2 0 0 0-2 2c0 .245.05.476.131.693-3.258 1.826-5.464 5.307-5.464 9.307C7.335 31.224 12.111 36 18.002 36s10.667-4.776 10.667-10.667c0-4-2.206-7.481-5.464-9.307" /><path fill="#9E5200" d="M19.404 18.6h-1.721l-2.73 2.132a.53.53 0 0 0-.112.28v1.178c0 .186.15.354.337.354h1.795v8.414c0 .188.15.355.355.355h2.076c.186 0 .336-.168.336-.355V18.954c0-.186-.149-.354-.336-.354" /></svg>
                                    </div>
                                </div>

                                {/* #3 */}
                                <div className="podiumTextBox" style={{ border: "2px solid #CD7F32", boxShadow: "0 2px 8px #CD7F32", height: "230px" }}>
                                    <h2>{data?.top3Funds[2]?.name}</h2>
                                    <p>{Number(data?.top3Funds[2]?.fund_amount).toLocaleString()}</p>
                                    <span className="podiumUnit">Points</span>
                                    <div className="podiumIcon">
                                        <svg width="48" height="48" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="iconify iconify--twemoji"><path fill="#55ACEE" d="m18 8-7-8H0l14 17 11.521-4.75z" /><path fill="#3B88C3" d="m25 0-7 8 5.39 7.312 1.227-1.489L36 0z" /><path fill="#FF8A3B" d="M23.205 16.026c.08-.217.131-.448.131-.693a2 2 0 0 0-2-2h-6.667a2 2 0 0 0-2 2c0 .245.05.476.131.693-3.258 1.826-5.464 5.307-5.464 9.307C7.335 31.224 12.111 36 18.002 36s10.667-4.776 10.667-10.667c0-4-2.206-7.481-5.464-9.307" /><path fill="#7C4119" d="m14.121 29.35 1.178-1.178a.345.345 0 0 1 .467-.038s1.159.861 2.056.861c.805 0 1.628-.673 1.628-1.496s-.842-1.514-2.225-1.514h-.639a.367.367 0 0 1-.354-.355v-1.552c0-.206.168-.355.354-.355h.639c1.309 0 2-.635 2-1.439 0-.805-.691-1.402-1.496-1.402-.823 0-1.346.43-1.626.747-.132.15-.355.15-.504.02l-1.141-1.122c-.151-.132-.132-.355 0-.486 0 0 1.533-1.646 3.57-1.646 2.169 0 4.039 1.328 4.039 3.422 0 1.439-1.085 2.505-1.926 2.897v.057c.879.374 2.262 1.533 2.262 3.141 0 2.038-1.776 3.572-4.357 3.572-2.354 0-3.552-1.16-3.944-1.664-.113-.134-.093-.34.019-.47" /></svg>
                                    </div>
                                </div>

                            </div>

                            {/* <DataTableBase 
                                columns={columns} 
                                data={data?.top3Funds ? data?.top3Funds : []} 
                                // data={[]} 
                            /> */}
                        </div>
                    </Col>

                    <Col className="mt-4 mb-5">
                        <div className="overview-table-div">
                            <div className="headerWrapper d-flex justify-content-between align-items-center pb-4">
                                <h2 className="chartTableHeader d-flex align-items-center">
                                    <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" width="33.75" height="33.75" viewBox="15 19 63 63"><path d="M28.1 48c-.1.7-.1 1.3-.1 2h-6c0-.7 0-1.3.1-2zm23.4-12h-3c-.8 0-1.5.7-1.5 1.5v13.1c0 .4.2.8.4 1.1l8.4 8.4c.6.6 1.5.6 2.1 0L60 58c.6-.6.6-1.5 0-2.1l-7-7.1V37.5c0-.8-.7-1.5-1.5-1.5"/><path d="M50 22c-14.8 0-26.9 11.5-27.9 26 0 .3-.1.7-.1 1h-4.5c-1.3 0-2 1.5-1.2 2.4l7.5 9.1c.6.7 1.7.7 2.3 0l7.5-9.1c.8-1 .1-2.4-1.2-2.4H28v-1c1-11.2 10.5-20 21.9-20 13 0 23.3 11.3 21.9 24.5-1 9.5-10 18.5-19.6 19.4-7.1.7-13.8-1.9-18.5-7-.6-.7-1.4-1.1-2.2-.1l-2.4 2.9c-.5.6-.1 1 .4 1.5 5.4 5.7 12.8 8.9 20.8 8.8 14.4-.2 26.5-11.6 27.5-26C79.1 35.7 66.1 22 50 22"/></svg>
                                    Recent Fund Added
                                </h2>
                                <button className="pointerButton" onClick={() => { localStorage.setItem("ba_tab", "3"); navigate('/fund-requests'); }}>
                                    <span className="pointer d-flex align-items-center">View all</span>
                                </button>
                            </div>
                                <DataTableBase
                                    columns={columns2}
                                    data={data?.last10Funds ? data?.last10Funds : []}
                                // data={[]} 
                                />
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default Overview;